import * as yup from 'yup';
import Schema from '@/schema/Schema';
import { I18n } from 'aws-amplify';
const UpdateCorporationSchema = Schema.object().shape({
    corporationName: yup
        .string()
        .required(I18n.get('COMMSG014'))
        .max(200, I18n.get('COMMSG022').replace('{{maxLength}}', '200'))
        .trim(),
    telNumberCorporation: yup
        .string()
        // .required(I18n.get('COMMSG014'))
        .trim(),

});

export default UpdateCorporationSchema;
